import type { ProductColor } from "@/types/catalog";

type ColorSwatchesProps = {
  colors: ProductColor[];
};

export function ColorSwatches({ colors }: ColorSwatchesProps) {
  if (!colors.length) return null;

  return (
    <div className="kmart-color-swatches" style={{ display: "flex", gap: 4, marginTop: 4 }}>
      {colors.map((color) => (
        <span
          key={color.name}
          title={color.name}
          style={{
            width: 14,
            height: 14,
            borderRadius: "50%",
            background: color.hex,
            border: "1px solid var(--rz-color-border)",
          }}
        />
      ))}
    </div>
  );
}
